(() => {
  const configNode = document.querySelector('[data-8rox-event-context]');
  if (!configNode) return;

  let context = {};
  try { context = JSON.parse(configNode.textContent); } catch { return; }

  let consentReady = false;
  const pending = [];

  const consentAllowsAnalytics = () => {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return false;
    return privacy.analyticsProcessingAllowed();
  };

  const pushWithConsent = (payload) => {
    if (!consentReady) {
      pending.push(payload);
      return;
    }
    if (!consentAllowsAnalytics()) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  };

  const emit = (name, detail = {}) => {
    const payload = { event: name, ...context, ...detail };
    document.dispatchEvent(new CustomEvent('8rox:tracking', { detail: payload }));
    pushWithConsent(payload);
  };

  const markConsentReady = () => {
    consentReady = true;
    pending.splice(0).forEach(pushWithConsent);
  };

  if (window.Shopify?.customerPrivacy) {
    markConsentReady();
  } else if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], markConsentReady);
  } else {
    window.addEventListener('load', markConsentReady, { once: true });
  }

  const pageEvent = context.pageType === 'product'
    ? '8rox_product_view'
    : context.pageType === 'collection'
      ? '8rox_collection_view'
      : '8rox_page_view';
  emit(pageEvent);

  document.addEventListener('8rox:add-to-cart', (event) => emit('8rox_add_to_cart', event.detail));

  document.addEventListener('click', (event) => {
    const checkout = event.target.closest('a[href*="/checkout"], button[name="checkout"], [data-checkout]');
    if (checkout) emit('8rox_begin_checkout');
  }, { capture: true });

  document.querySelectorAll('[data-stock-request-success]').forEach(() => emit('8rox_stock_request_submit'));
  document.querySelectorAll('.newsletter-success').forEach(() => emit('8rox_newsletter_signup'));
  document.querySelectorAll('.rox-contact__status:not(.rox-contact__status--error)').forEach(() => emit('8rox_contact_submit'));
  document.querySelectorAll('[data-waitlist-success]').forEach(() => emit('8rox_ghost_pulse_waitlist_submit'));

  document.addEventListener('visitorConsentCollected', () => emit('8rox_consent_updated'));
})();
